import React, {memo} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MUIContainer from '@/components/MUI-Components/MUI-Container';
import {contentMaxWidth, colors, fontSize, fontWeight, lineHeightRatio, spacing} from '@/styles/tokens';
import type {overviewContent} from '@/util/contents/drawpost-data';

interface OverviewProps {
    content: typeof overviewContent;
}

const sectionSx = {
    bgcolor: colors.background.slate50,
    position: 'relative'
} as const;

const innerSx = {
    maxWidth: contentMaxWidth.standard,
    m: '0 auto',
    textAlign: 'center',
    pt: {xs: spacing[32], md: spacing[40]}
} as const;

const paragraphSx = {
    color: colors.text.primary,
    fontSize: fontSize[16],
    fontWeight: fontWeight.regular,
    lineHeight: lineHeightRatio.looser,
    mt: 2
} as const;

const Overview = memo(function Overview({content}: OverviewProps) {
    return (
        <Box className="top-space bottom-spacing mobile-top-padding mobile-padding-bottom" sx={sectionSx}>
            <MUIContainer>
                <Box sx={innerSx}>
                    {content.paragraphs.map((text, index) => (
                        <Typography key={index} sx={paragraphSx} className="font-regular-text remove-underline">
                            {text}
                        </Typography>
                    ))}
                </Box>
            </MUIContainer>
        </Box>
    );
});

export default Overview;
